export default __webpack_public_path__ + "static/media/Mark-5-HUD-Connection Lines.7775e1c3.jpg";